import type { ReactNode } from 'react'
import React from 'react'
import { Scrollbar } from '../../Scrollbar'

type TableBodyWrapperProps = {
  maxHeight?: number
  children: ReactNode
}

export const TableBodyWrapper = ({ maxHeight, children }: TableBodyWrapperProps) => {
  if (maxHeight) {
    return <Scrollbar maxHeight={maxHeight}>{children}</Scrollbar>
  }

  return children
}
